import React, { useState, useEffect } from 'react'

import {
  Icon,
  ImageAdd,
  classnames,
} from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { string, func } from 'prop-types'

import { NOOP } from 'Utils/stableDefaults'

import { useImageSearch } from './Hooks/useImageSearch'

let ImageSearchDropdown

function ButtonIcon() {
  return <ImageAdd width="24" height="24" />
}

function ImageSearch({ locale = 'en', onActiveChange = NOOP }) {
  const [isDropdownLoaded, setIsDropdownLoaded] = useState(false)

  const {
    // refs
    wrapperRef,
    triggerRef,
    // values
    isActive,
    isUploading,
    // actions
    triggerImageSearch,
    handleFileDrop,
  } = useImageSearch({ onActiveChange })

  useEffect(() => {
    let isMounted = true

    if (isActive && !ImageSearchDropdown && !isDropdownLoaded) {
      import('Pods/LazyLoaded/ImageSearchDropdown/ImageSearchDropdown')
        .then((module) => {
          if (isMounted) {
            ImageSearchDropdown = module.default
            setIsDropdownLoaded(true)
          }
        })
        .catch((error) => {
          console.error('Failed to load ImageSearchDropdown:', error)
        })
    }

    return () => {
      isMounted = false
    }
  }, [isActive, isDropdownLoaded])

  function importImageSearchDropdown() {
    import('Pods/LazyLoaded/ImageSearchDropdown/ImageSearchDropdown')
      .then((module) => {
        ImageSearchDropdown = module.default
        setIsDropdownLoaded(true)
      })
      .catch((error) => {
        console.error('Failed to load ImageSearchDropdown:', error)
      })
  }

  function handleMouseEnter() {
    if (!isDropdownLoaded && !ImageSearchDropdown) {
      importImageSearchDropdown()
    }
  }

  function handleTouchStart() {
    if (!isDropdownLoaded && !ImageSearchDropdown) {
      importImageSearchDropdown()
    }
  }

  return (
    <div
      className={classnames('wayfinder__action', 'wayfinder__image-search-wrapper', isActive && 'is-active')}
      onClick={triggerImageSearch}
      onMouseEnter={handleMouseEnter}
      onTouchStart={handleTouchStart}
      ref={triggerRef}
    >
      <div className="wayfinder__image-search">
        <span className="wayfinder__action-icon">
          <Icon
            color="dark"
            notSpaced
            size="medium"
            svgComponent={ButtonIcon}
            className="wayfinder__action-icon-svg"
        />
        </span>
      </div>
      {isActive && isDropdownLoaded && ImageSearchDropdown && (
        <div className="popover wayfinder__image-search-popover is-active">
          <div className="popover-container" ref={wrapperRef}>
            <ImageSearchDropdown
              isLoading={isUploading}
              handleFileDrop={handleFileDrop}
              locale={locale}
          />
          </div>
        </div>
      )}
    </div>
  )
}

ImageSearch.propTypes = {
  locale: string,
  onActiveChange: func,
}

export default ImageSearch
